import { createContext, useContext } from 'react';
import { useReviewFlow } from '../hooks/useReviewFlow';

/**
 * For use when multiple sibling components need the same review flow data
 * (e.g., a review CTA in an overview card and a reviews list card on the same page).
 * Calls useReviewFlow once and shares the result via context, eliminating
 * duplicate data fetching and reviewSubmitted prop drilling.
 *
 * For single-consumer cases, use the useReviewFlow hook directly instead.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ReviewFlowContext = /*#__PURE__*/createContext(null);
export function ReviewFlowProvider({
  appContext,
  children,
  entityId,
  entityPortalId,
  isPreview,
  reviewType,
  reviewerUserId,
  skip
}) {
  const reviewFlow = useReviewFlow({
    appContext,
    entityId,
    entityPortalId,
    isPreview,
    reviewType,
    reviewerUserId,
    skip
  });
  return /*#__PURE__*/_jsx(ReviewFlowContext.Provider, {
    value: reviewFlow,
    children: children
  });
}
export function useReviewFlowContext() {
  const context = useContext(ReviewFlowContext);
  if (!context) {
    throw new Error('useReviewFlowContext must be used within a ReviewFlowProvider');
  }
  return context;
}